/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { Box, Radio, Stack, Title } from "@mantine/core";
import {
  FetchUserAttributesOutput,
  UpdateUserAttributesInput,
  UpdateUserAttributesOutput,
  fetchUserAttributes,
  updateUserAttributes,
} from "aws-amplify/auth";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import { appShowNotification } from "@/utils/utils";
import { listLocations } from "@/graphql/queries";
import { ListLocationsQuery } from "@/API";
import BoxLoader from "../BoxLoader";

const client = generateClient();

const ChangeLocation = () => {
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [locationId, setLocationId] = useState("");

  useEffect(() => {
    onGetLocations();
  }, []);

  const onGetLocations = async () => {
    setIsLoading(true);
    try {
      const userInfo: FetchUserAttributesOutput = await fetchUserAttributes();
      const locationData: any = await client.graphql<
        GraphQLQuery<ListLocationsQuery>
      >({ query: listLocations });
      const locationList: any = await locationData.data.listLocations.items;
      setLocations(locationList);
      userInfo["custom:location"] !== undefined &&
        setLocationId(userInfo["custom:location"]);
    } catch (e) {
      console.log(e);
    }
    setIsLoading(false);
  };

  const handleSetLocation = async (locationId: string) => {
    setLocationId(locationId);
    try {
      const updatedAttrInput: UpdateUserAttributesInput = {
        userAttributes: { "custom:location": locationId },
      };
      const updatedAttrOutput: UpdateUserAttributesOutput =
        await updateUserAttributes(updatedAttrInput);
      console.log("Set new location!", updatedAttrOutput);
      appShowNotification({
        title: "Location updated successfully!",
        type: "success",
      });
    } catch (error) {
      appShowNotification({ title: "Fail top updated!", type: "error" });
      console.log(error);
    }
  };

  return (
    <Box p={"md"} pos={"relative"}>
      <Title order={3}>Change location</Title>
      {isLoading && <BoxLoader />}
      {!isLoading && (
        <Stack mt={"sm"}>
          <Radio.Group
            name="userLocation"
            label=""
            value={locationId}
            onChange={handleSetLocation}
          >
            {locations.map((loc: any) => (
              <Radio
                variant="outline"
                value={loc.id}
                mb={10}
                checked={loc?.id == locationId}
                label={loc?.name}
              />
            ))}
          </Radio.Group>
        </Stack>
      )}
    </Box>
  );
};

export default ChangeLocation;
